module.exports = __webpack_public_path__ + "static/media/sf-steuart-2-spear-2.630db672.png";